const request: typeof fetch = (input, init) => {
  const modifiedInit: RequestInit = Object.assign({}, init);
  modifiedInit.credentials = 'include';
  return fetch(input, modifiedInit);
};

export default request;
